module.exports = __webpack_public_path__ + "img/gsgl3.f1b27345.png";